<p class="filter-title" (click)="toggleShowFilter()">
  {{ title }}
  <mat-icon [class.rotate-180]="showFilter"> keyboard_arrow_down </mat-icon>
</p>
<div class="filter-fields" [class.show]="showFilter">
  <ng-content></ng-content>
</div>
<div class="filter-line"></div>
